(function () {
  'use strict';

  var MODE = Object.freeze({
    SELECT_SIZE: 'select-size',
    PREORDER: 'preorder',
    ADD: 'add',
    NOTIFY: 'notify',
  });
  var MAX_CHALLENGE_RESTARTS_PER_SUBMISSION = 1;

  var COPY = Object.freeze({
    selectSize: 'SELECT SIZE',
    preorder: 'PRE-ORDER',
    notify: 'NOTIFY ME',
    submit: 'NOTIFY ME',
    loading: 'SAVING…',
    checking: 'CHECKING…',
    checkingSecurity: 'Checking security…',
    success: "You're on the list. We'll email you when this size is back.",
    duplicate: "You're already on the list for this size.",
    alreadyAvailable: 'This size is available now. Refresh to purchase.',
    invalidEmail: 'Enter a valid email address.',
    consent: 'Confirm the alert consent to continue.',
    challenge: 'Security check could not be completed. Refresh and try again.',
    challengeFailed: 'Security check expired or could not be verified. Refresh and try again.',
    temporarilyUnavailable: 'Restock alerts are temporarily unavailable. Try again in a few minutes.',
    invalidRequest: 'This size changed while the page was open. Refresh and try again.',
    unavailable: 'Restock alerts are unavailable right now.',
    error: "We couldn't save your request. Try again.",
  });

  function normalizeId(value) {
    var match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function parseJson(node, fallback) {
    try {
      return JSON.parse(node ? node.textContent : '');
    } catch {
      return fallback;
    }
  }

  function resolveState(input) {
    if (input.requiresSize && !input.sizeSelected) return MODE.SELECT_SIZE;
    if (!input.variantId) return input.requiresSize ? MODE.SELECT_SIZE : MODE.NOTIFY;
    if (input.preorderIds.has(input.variantId)) return MODE.PREORDER;
    return input.available ? MODE.ADD : MODE.NOTIFY;
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 254;
  }

  function storefrontProductUrl(handle) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      root = window.Shopify.routes.root;
    }
    root = String(root || '').replace(/^\/+|\/+$/g, '');
    root = root ? '/' + root + '/' : '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js?_zico_inventory=' + Date.now();
  }

  function setButtonLabel(button, label) {
    if (!button) return;
    var labelNode = button.querySelector('span');
    if (labelNode && labelNode.textContent.trim() !== label) labelNode.textContent = label;
    if (!labelNode && button.textContent.trim() !== label) button.textContent = label;
  }

  function setButtonState(button, mode, addLabel, selectSizeEnabled) {
    if (!button) return;
    var disabled = mode === MODE.SELECT_SIZE && !selectSizeEnabled;
    var type = mode === MODE.NOTIFY ? 'button' : 'submit';
    var label = addLabel;
    if (mode === MODE.SELECT_SIZE) label = COPY.selectSize;
    if (mode === MODE.PREORDER) label = COPY.preorder;
    if (mode === MODE.NOTIFY) label = COPY.notify;

    if (button.disabled !== disabled) button.disabled = disabled;
    if (button.getAttribute('type') !== type) button.setAttribute('type', type);
    if (button.getAttribute('aria-disabled') !== String(disabled)) {
      button.setAttribute('aria-disabled', String(disabled));
    }
    var hidden = mode === MODE.NOTIFY;
    if (button.hidden !== hidden) button.hidden = hidden;
    var buttonGroup = button.closest('.product-form__buttons');
    if (buttonGroup && buttonGroup.hidden !== hidden) buttonGroup.hidden = hidden;
    setButtonLabel(button, label);
  }

  function loadTurnstile() {
    if (window.turnstile) return window.Promise.resolve(window.turnstile);
    if (window.__zicoTurnstilePromise) return window.__zicoTurnstilePromise;
    window.__zicoTurnstilePromise = new window.Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-zico-turnstile-script]');
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.dataset.zicoTurnstileScript = 'true';
        document.head.appendChild(script);
      }
      script.addEventListener('load', function () {
        if (window.turnstile) resolve(window.turnstile);
        else reject(new window.Error('turnstile_unavailable'));
      }, { once: true });
      script.addEventListener('error', function () {
        reject(new window.Error('turnstile_unavailable'));
      }, { once: true });
    });
    return window.__zicoTurnstilePromise;
  }

  class ZicoCommerceState extends window.HTMLElement {
    connectedCallback() {
      if (this.dataset.zicoBound === 'true') return;
      this.dataset.zicoBound = 'true';

      this.buyBlock = this.closest('[data-zico-buy-block]');
      if (!this.buyBlock) return;

      this.productForm = this.buyBlock.querySelector('product-form');
      this.variantInput = this.buyBlock.querySelector('.product-variant-id');
      this.submitButton = this.buyBlock.querySelector('[id^="ProductSubmitButton-"]');
      this.noteInput = this.querySelector('[data-zico-preorder-note]');
      this.campaignInput = this.querySelector('[data-zico-preorder-campaign]');
      this.preorderMessage = this.querySelector('[data-zico-preorder-message]');
      this.restockForm = this.querySelector('[data-zico-restock-form]');
      this.restockFieldset = this.restockForm && this.restockForm.querySelector('fieldset');
      this.emailInput = this.querySelector('[data-zico-restock-email]');
      this.consentInput = this.querySelector('[data-zico-restock-consent]');
      this.restockSubmit = this.querySelector('[data-zico-restock-submit]');
      this.restockSubmitLabel = this.querySelector('[data-zico-restock-submit-label]');
      this.statusNode = this.querySelector('[data-zico-restock-status]');
      this.turnstileNode = this.querySelector('[data-zico-turnstile]');
      this.endpoint = String(this.dataset.endpoint || '').trim();
      this.turnstileSiteKey = String(this.dataset.turnstileSiteKey || '').trim();
      this.turnstileToken = '';
      this.turnstileWidgetId = null;
      this.challengeNeedsRestart = false;
      this.challengeRestartCount = 0;
      this.pendingRestockSubmit = false;
      this.restockSubmissionInFlight = false;
      this.syncTimer = null;
      this.followupSyncTimer = null;
      this.currentMode = this.dataset.mode || MODE.ADD;
      this.currentVariantId = '';
      this.preorderIds = new Set(
        parseJson(this.querySelector('[data-zico-preorder-variant-ids]'), []).map(normalizeId).filter(Boolean),
      );
      this.variants = new Map(
        parseJson(this.buyBlock.querySelector('[data-zico-product-variants]'), []).map(function (variant) {
          return [normalizeId(variant.id), variant];
        }),
      );
      this.addLabel =
        (this.submitButton && this.submitButton.dataset.zicoAddLabel) || 'ADD TO CART';
      this.abortController = new window.AbortController();
      this.lastSubscribedVariantId = '';

      this.bindEvents();
      this.observeThemeChanges();
      this.sync();
      this.refreshCurrentAvailability();
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      if (this.observer) this.observer.disconnect();
      window.clearTimeout(this.syncTimer);
      window.clearTimeout(this.followupSyncTimer);
      this.syncTimer = null;
      this.followupSyncTimer = null;
      this.turnstileToken = '';
      this.challengeNeedsRestart = false;
      this.challengeRestartCount = 0;
      this.pendingRestockSubmit = false;
      this.restockSubmissionInFlight = false;
      if (this.turnstileWidgetId !== null && this.turnstileWidgetId !== undefined) {
        try {
          if (window.turnstile && typeof window.turnstile.remove === 'function') {
            window.turnstile.remove(this.turnstileWidgetId);
          }
        } catch {
          // The element is already detached; clearing local state is sufficient.
        }
        this.turnstileWidgetId = null;
      }
      this.dataset.zicoBound = 'false';
    }

    bindEvents() {
      var signal = this.abortController.signal;
      var schedule = this.scheduleSync.bind(this);
      document.addEventListener('change', schedule, { capture: true, signal: signal });
      document.addEventListener('variant:change', schedule, { signal: signal });
      document.addEventListener('variantChange', schedule, { signal: signal });
      if (this.restockForm) {
        this.restockForm.addEventListener('submit', this.handleRestockSubmit.bind(this), { signal: signal });
      }
    }

    observeThemeChanges() {
      if (!window.MutationObserver) return;
      this.observer = new window.MutationObserver(this.scheduleSync.bind(this));
      if (this.productForm) {
        this.observer.observe(this.productForm, {
          attributes: true,
          attributeFilter: ['data-zico-size-selected'],
        });
      }
      if (this.variantInput) {
        this.observer.observe(this.variantInput, {
          attributes: true,
          attributeFilter: ['value', 'disabled'],
        });
      }
      if (this.submitButton) {
        this.observer.observe(this.submitButton, { childList: true, subtree: true });
      }
      var stickyButton = document.querySelector('[data-zico-sticky-submit]');
      if (stickyButton) {
        this.observer.observe(stickyButton, {
          attributes: true,
          attributeFilter: ['disabled', 'type'],
          childList: true,
          subtree: true,
        });
      }
    }

    scheduleSync() {
      if (!this.isConnected) return;
      window.clearTimeout(this.syncTimer);
      window.clearTimeout(this.followupSyncTimer);
      this.syncTimer = window.setTimeout(() => {
        this.syncTimer = null;
        if (this.isConnected) this.sync();
      }, 40);
      this.followupSyncTimer = window.setTimeout(() => {
        this.followupSyncTimer = null;
        if (this.isConnected) this.sync();
      }, 140);
    }

    selectedVariant() {
      var variantId = normalizeId(this.variantInput && this.variantInput.value);
      return { id: variantId, record: this.variants.get(variantId) || null };
    }

    async refreshCurrentAvailability() {
      var handle = String(this.dataset.productHandle || '').trim();
      var productId = normalizeId(this.dataset.productId);
      if (!handle || !productId || typeof window.fetch !== 'function') return;

      try {
        var response = await window.fetch(storefrontProductUrl(handle), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: this.abortController && this.abortController.signal,
        });
        if (!response || !response.ok) return;
        var product = await response.json();
        if (!product || typeof product !== 'object') return;
        if (normalizeId(product.id) !== productId) return;
        if (String(product.handle || '').trim().toLowerCase() !== handle.toLowerCase()) return;
        if (!Array.isArray(product.variants)) return;

        var updated = false;
        product.variants.forEach((variant) => {
          if (!variant || typeof variant !== 'object' || typeof variant.available !== 'boolean') return;
          var record = this.variants.get(normalizeId(variant.id));
          if (!record) return;
          record.currentAvailable = variant.available;
          updated = true;
        });
        if (updated && this.isConnected) this.sync();
      } catch {
        // Keep the rendered Shopify state when the availability check cannot complete.
      }
    }

    sync() {
      var selected = this.selectedVariant();
      var requiresSize = Boolean(this.productForm && this.productForm.dataset.zicoRequiresSize === 'true');
      var sizeSelected = !requiresSize || Boolean(this.productForm && this.productForm.dataset.zicoSizeSelected === 'true');
      var restockAvailable = Boolean(selected.record && selected.record.restock_available !== false);
      var available = Boolean(restockAvailable && selected.record && (
        typeof selected.record.currentAvailable === 'boolean'
          ? selected.record.currentAvailable
          : selected.record.available && !selected.record.quantity_rule_soldout
      ));
      var mode = resolveState({
        requiresSize: requiresSize,
        sizeSelected: sizeSelected,
        variantId: selected.id,
        preorderIds: this.preorderIds,
        available: available,
      });
      var variantChanged = selected.id !== this.currentVariantId;

      this.currentMode = mode;
      this.currentVariantId = selected.id;
      this.dataset.mode = mode;

      if (this.variantInput) {
        var disableVariant = mode === MODE.SELECT_SIZE || mode === MODE.NOTIFY;
        if (this.variantInput.disabled !== disableVariant) this.variantInput.disabled = disableVariant;
      }
      if (this.noteInput) {
        this.noteInput.disabled = mode !== MODE.PREORDER;
        this.noteInput.value = mode === MODE.PREORDER ? 'Preorder' : '';
      }
      if (this.campaignInput) {
        this.campaignInput.disabled = mode !== MODE.PREORDER;
        this.campaignInput.value = mode === MODE.PREORDER ? '2-3-week-20260828' : '';
      }
      if (variantChanged) this.resetRestockForm();
      if (this.preorderMessage) this.preorderMessage.hidden = mode !== MODE.PREORDER;
      var showRestockForm = mode === MODE.NOTIFY;
      if (this.restockForm) {
        this.restockForm.dataset.expanded = String(showRestockForm);
        this.restockForm.hidden = !showRestockForm;
      }
      if (showRestockForm && this.turnstileWidgetId === null) this.initializeChallenge();

      setButtonState(this.submitButton, mode, this.addLabel, true);
      this.syncSticky(mode);

      this.dispatchEvent(
        new window.CustomEvent('zico:commerce-state', {
          bubbles: true,
          detail: { mode: mode, variantId: selected.id },
        }),
      );
    }

    syncSticky(mode) {
      var sticky = document.querySelector('[data-zico-sticky-atc]');
      if (!sticky) return;
      if (mode === MODE.NOTIFY) sticky.hidden = true;
      var button = sticky.querySelector('[data-zico-sticky-submit]');
      var input = sticky.querySelector('.product-variant-id');
      if (!button) return;

      if (!button.dataset.zicoAddLabel) {
        button.dataset.zicoAddLabel = this.addLabel;
      }
      if (input && this.currentVariantId) input.value = this.currentVariantId;
      setButtonState(button, mode, button.dataset.zicoAddLabel || this.addLabel, true);
      button.dataset.zicoCommerceMode = mode;
    }

    resetRestockForm() {
      if (!this.restockForm) return;
      this.pendingRestockSubmit = false;
      this.restockSubmissionInFlight = false;
      this.challengeNeedsRestart = false;
      this.challengeRestartCount = 0;
      this.restockForm.dataset.state = 'idle';
      if (this.emailInput) this.emailInput.value = '';
      if (this.consentInput) this.consentInput.checked = false;
      if (this.restockSubmit) this.restockSubmit.disabled = !this.endpoint || !this.turnstileSiteKey;
      if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.submit;
      this.resetChallenge();
      this.setStatus(this.endpoint && this.turnstileSiteKey ? '' : COPY.unavailable, false);
    }

    async initializeChallenge() {
      if (!this.endpoint || !this.turnstileSiteKey || !this.turnstileNode) return;
      try {
        var turnstile = await loadTurnstile();
        if (!this.isConnected || this.turnstileWidgetId !== null) return;
        this.turnstileWidgetId = turnstile.render(this.turnstileNode, {
          sitekey: this.turnstileSiteKey,
          action: 'restock_subscribe',
          appearance: 'interaction-only',
          size: 'flexible',
          theme: 'light',
          language: 'en',
          retry: 'never',
          'refresh-expired': 'manual',
          'refresh-timeout': 'manual',
          callback: (token) => {
            this.turnstileToken = String(token || '');
            this.challengeNeedsRestart = false;
            if (this.pendingRestockSubmit && this.turnstileToken) {
              this.submitRestockSubscription();
            }
          },
          'expired-callback': () => {
            this.handleChallengeRetry();
          },
          'error-callback': () => {
            this.handleChallengeRetry();
          },
          'timeout-callback': () => {
            this.handleChallengeRetry();
          },
        });
      } catch {
        this.turnstileToken = '';
        if (this.pendingRestockSubmit) this.handleChallengeFailure();
      }
    }

    resetChallenge() {
      this.turnstileToken = '';
      if (this.turnstileWidgetId !== null && window.turnstile) {
        try {
          window.turnstile.reset(this.turnstileWidgetId);
        } catch {
          this.turnstileWidgetId = null;
          this.initializeChallenge();
        }
      }
    }

    setStatus(message, assertive) {
      if (!this.statusNode) return;
      this.statusNode.textContent = message;
      this.statusNode.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
      if (message) this.statusNode.setAttribute('tabindex', '-1');
      else this.statusNode.removeAttribute('tabindex');
    }

    restoreRestockSubmit() {
      this.pendingRestockSubmit = false;
      this.restockSubmissionInFlight = false;
      if (this.restockSubmit) this.restockSubmit.disabled = false;
      if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.submit;
    }

    handleChallengeFailure() {
      this.turnstileToken = '';
      if (!this.pendingRestockSubmit) return;
      if (this.restockForm) this.restockForm.dataset.state = 'error';
      this.restoreRestockSubmit();
      this.setStatus(COPY.challenge, true);
    }

    handleChallengeRetry() {
      this.turnstileToken = '';
      this.challengeNeedsRestart = true;
      if (!this.pendingRestockSubmit) return;
      if (this.challengeRestartCount >= MAX_CHALLENGE_RESTARTS_PER_SUBMISSION) {
        this.handleChallengeFailure();
        return;
      }
      this.challengeRestartCount += 1;
      if (this.restockForm) this.restockForm.dataset.state = 'loading';
      if (this.restockSubmit) this.restockSubmit.disabled = true;
      if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.checking;
      this.setStatus(COPY.checkingSecurity, false);
      try {
        if (!this.restartChallenge()) throw new window.Error('turnstile_restart_failed');
        this.challengeNeedsRestart = false;
      } catch {
        this.handleChallengeFailure();
      }
    }

    restartChallenge() {
      if (
        this.turnstileWidgetId === null ||
        !window.turnstile ||
        typeof window.turnstile.reset !== 'function'
      ) {
        return false;
      }
      window.turnstile.reset(this.turnstileWidgetId);
      return true;
    }

    async ensureChallengeStarted() {
      try {
        if (this.turnstileWidgetId === null) await this.initializeChallenge();
        if (!this.pendingRestockSubmit || this.turnstileToken) return;
        if (this.challengeNeedsRestart) {
          this.handleChallengeRetry();
          return;
        }
        if (this.turnstileWidgetId === null) {
          throw new window.Error('turnstile_unavailable');
        }
      } catch {
        this.handleChallengeFailure();
      }
    }

    handleRestockSubmit(event) {
      event.preventDefault();
      if (this.pendingRestockSubmit || this.restockSubmissionInFlight) return;
      this.submitRestockSubscription();
    }

    async submitRestockSubscription() {
      this.sync();
      if (this.currentMode !== MODE.NOTIFY) return;
      if (!this.endpoint || !this.turnstileSiteKey) {
        this.setStatus(COPY.unavailable, false);
        return;
      }

      var email = String((this.emailInput && this.emailInput.value) || '').trim().toLowerCase();
      if (!validEmail(email)) {
        this.restoreRestockSubmit();
        this.restockForm.dataset.state = 'error';
        this.setStatus(COPY.invalidEmail, true);
        if (this.emailInput) this.emailInput.focus();
        return;
      }
      if (!this.consentInput || !this.consentInput.checked) {
        this.restoreRestockSubmit();
        this.restockForm.dataset.state = 'error';
        this.setStatus(COPY.consent, true);
        if (this.consentInput) this.consentInput.focus();
        return;
      }
      if (!this.currentVariantId) {
        this.restoreRestockSubmit();
        this.setStatus(COPY.error, true);
        return;
      }
      if (!this.turnstileToken) {
        this.pendingRestockSubmit = true;
        this.restockForm.dataset.state = 'loading';
        if (this.restockSubmit) this.restockSubmit.disabled = true;
        if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.checking;
        this.setStatus(COPY.checkingSecurity, false);
        await this.ensureChallengeStarted();
        return;
      }

      this.pendingRestockSubmit = false;
      this.restockSubmissionInFlight = true;
      this.restockForm.dataset.state = 'loading';
      if (this.restockSubmit) this.restockSubmit.disabled = true;
      if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.loading;
      this.setStatus(COPY.loading, false);

      try {
        var response = await window.fetch(this.endpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            productId: 'gid://shopify/Product/' + normalizeId(this.dataset.productId),
            productHandle: String(this.dataset.productHandle || ''),
            variantId: 'gid://shopify/ProductVariant/' + this.currentVariantId,
            consent: true,
            turnstileToken: this.turnstileToken,
          }),
        });
        var result = {};
        try {
          result = await response.json();
        } catch {
          result = {};
        }

        if (result.status === 'already_available') {
          this.restockForm.dataset.state = 'available';
          this.setStatus(COPY.alreadyAvailable, false);
          return;
        }
        if (result.error === 'challenge_failed') {
          this.restockForm.dataset.state = 'error';
          this.setStatus(COPY.challengeFailed, true);
          if (this.restockSubmit) this.restockSubmit.disabled = false;
          return;
        }
        if (result.error === 'try_later') {
          this.restockForm.dataset.state = 'error';
          this.setStatus(COPY.temporarilyUnavailable, true);
          if (this.restockSubmit) this.restockSubmit.disabled = false;
          return;
        }
        if (result.error === 'invalid_request') {
          this.restockForm.dataset.state = 'error';
          this.setStatus(COPY.invalidRequest, true);
          if (this.restockSubmit) this.restockSubmit.disabled = false;
          return;
        }
        if (response.status === 409 || result.status === 'duplicate') {
          this.restockForm.dataset.state = 'duplicate';
          this.setStatus(COPY.duplicate, false);
          return;
        }
        if (!response.ok) throw new window.Error('subscription_failed');

        this.lastSubscribedVariantId = this.currentVariantId;
        this.restockForm.dataset.state = 'success';
        this.setStatus(COPY.success, false);
      } catch {
        this.restockForm.dataset.state = 'error';
        this.setStatus(COPY.error, true);
        if (this.restockSubmit) this.restockSubmit.disabled = false;
      } finally {
        this.restockSubmissionInFlight = false;
        this.resetChallenge();
        if (this.restockSubmitLabel) this.restockSubmitLabel.textContent = COPY.submit;
      }
    }
  }

  if (!window.customElements.get('zico-commerce-state')) {
    window.customElements.define('zico-commerce-state', ZicoCommerceState);
  }

  window.ZicoPreorderBackInStock = Object.freeze({ MODE: MODE, resolveState: resolveState, validEmail: validEmail });
})();

